var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5343 0.935901L9.61496 0.916748L9.59177 2.0297H5.33896V0.926325H4.41942V2.0297H0.833252V2.7654V3.86878V14.9033H14.1666V3.86878V2.7654V2.0297H10.5115L10.5343 0.935901ZM1.75279 3.86878H13.247V13.9838H1.75279V3.86878ZM6.39635 8.65066L8.6031 11.593H10.4421V6.07575L8.6031 6.07612V9.01845L6.39635 6.07612L4.55739 6.07575V11.5926L6.39635 11.593V8.65066Z"
  })));
}
export default SvgCommonIconCalendar;